import React from "react";
import { Field } from "redux-form";
import { FormRoutePointField } from "../../components/fields";
import styles from "./style.module.css";

export const FormRoutePoints = React.memo((
  {
    fields,
  }) => {
  return (
    <ul className={styles.list}>
      {fields.map((item, index) =>
        <li key={index} className={styles.listItem}>
          <Field
            label={index === 0 ? "From" : "Where to"}
            dropOff={index === 1}
            component={FormRoutePointField}
            name={item}
            index={index}
          />
        </li>,
      )}
    </ul>

  );
});
